import { ADJUST_LINK } from './constants';
import { IS_ANDROID_USER, IS_IOS_USER, IS_USER_AGENT_WITH_AVAILABLE_APP } from './userAgentUtils';

export const deeplinkUrl = (campaign: string, deeplink?: string | null, osName?: string) => {
  const params = new URLSearchParams();
  if (osName === 'android') {
    params.append('adj_t', import.meta.env.VITE_ADJUST_CHANNEL_ANDROID);
  } else if (osName === 'ios') {
    params.append('adj_t', import.meta.env.VITE_ADJUST_CHANNEL_IOS);
  } else {
    params.append(
      'adj_t',
      `${import.meta.env.VITE_ADJUST_CHANNEL_IOS}_${import.meta.env.VITE_ADJUST_CHANNEL_ANDROID}`,
    );
  }
  params.append('adj_campaign', campaign);

  return `${ADJUST_LINK}?${params.toString()}&deeplink=${window.encodeURIComponent(`${import.meta.env.VITE_DEEPLINK_SCHEMA}://${deeplink ?? 'explore'}`)}`;
};

export const responsiveDeeplinkUrl = (
  campaign: string,
  deeplink?: string | null,
  forceDeeplink = IS_USER_AGENT_WITH_AVAILABLE_APP,
) => {
  if (!forceDeeplink) {
    return 'https://www.fishbrain.com';
  }
  if (IS_ANDROID_USER) {
    return deeplinkUrl(campaign, deeplink, 'android');
  }
  if (IS_IOS_USER) {
    return deeplinkUrl(campaign, deeplink, 'ios');
  }
  return deeplinkUrl(campaign, deeplink);
};
